module.exports = __webpack_public_path__ + "img/pbms-mobile.85935a9b.webp";